module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-9539.f845acea.jpg";